// import { useEffect, useRef, useState } from "react";
// import { useItemSearch } from "./useItemSearch";
// import styles from "./ItemChipSearch.module.css";
// export function ItemChipSearch({
//   mode,
//   selectedItems,
//   onAdd,
//   onRemove,
//   warehouseId,
//   managerId,
// }) {
//   const {
//     keyword,
//     setKeyword,
//     results,
//     setResults,
//     loading,
//     currentIndex,
//     setCurrentIndex,
//   } = useItemSearch(warehouseId, managerId);
//   const inputRef = useRef(null);
//   const rowRefs = useRef([]);
//   const [open, setOpen] = useState(false);

//   const handleKey = (e) => {
//     if (!open || results.length === 0) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setCurrentIndex((i) => Math.min(i + 1, results.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setCurrentIndex((i) => Math.max(i - 1, 0));
//     } else if (e.key === "Enter") {
//       e.preventDefault();
//       const item = results[currentIndex];
//       if (item) handleSelect(item);
//     } else if (e.key === "Escape") {
//       setOpen(false);
//     }
//   };

//   const handleSelect = (item) => {
//     const alreadyAdded = selectedItems.some(
//       (s) => s.itemNo === item.itemNo && s.warehouseId === item.warehouseId,
//     );
//     if (!alreadyAdded) onAdd(item);
//     setKeyword("");
//     setResults([]);
//     setOpen(false);
//     inputRef.current?.focus();
//   };

//   useEffect(() => {
//     setOpen(results.length > 0 && keyword.trim().length > 0);
//   }, [results.length, keyword]);

//   useEffect(() => {
//     if (rowRefs.current[currentIndex]) {
//       rowRefs.current[currentIndex].scrollIntoView({ block: "nearest" });
//     }
//   }, [currentIndex]);

//   return (
//     <div className={styles.formGroup}>
//       <label className={mode ? styles.labelDark : ""}>Products / Items</label>

//       {/* ── Chips ── */}
//       {selectedItems.length > 0 && (
//         <div
//           className={`${styles.chipContainer} ${mode ? styles.chipContainerDark : ""}`}
//         >
//           {selectedItems.map((item, i) => (
//             <span
//               key={`${item.itemNo}-${item.warehouseId || i}`}
//               className={`${styles.chip} ${mode ? styles.chipDark : ""}`}
//             >
//               <span className={styles.chipLabel}>{item.itemNo}</span>
//               {/* {item.warehouse && (
//                 <span className={styles.chipWarehouse}>{item.warehouse}</span>
//               )} */}
//               <button
//                 type="button"
//                 className={`${styles.chipRemove} ${mode ? styles.chipRemoveDark : ""}`}
//                 onClick={() => onRemove(item)}
//                 aria-label={`Remove ${item.itemNo}`}
//               >
//                 ×
//               </button>
//             </span>
//           ))}
//         </div>
//       )}

//       {/* ── Search input ── */}
//       <div className={styles.itemSearchWrapper}>
//         <input
//           disabled={!warehouseId}
//           ref={inputRef}
//           type="text"
//           value={keyword}
//           onChange={(e) => setKeyword(e.target.value)}
//           onKeyDown={handleKey}
//           placeholder={
//             warehouseId
//               ? "Search by item no or product name..."
//               : "Select warehouse first"
//           }
//           className={`${styles.itemSearchInput} ${mode ? styles.inputDark : ""}`}
//           autoComplete="off"
//           style={{ cursor: warehouseId ? "pointer" : "not-allowed" }}
//         />
//         {loading && <span className={styles.itemSearchSpinner} />}

//         {/* ── Table Dropdown ── */}
//         {open && (
//           <div
//             className={`${styles.itemDropdown} ${mode ? styles.itemDropdownDark : ""}`}
//           >
//             {/* Table header */}
//             <div
//               className={`${styles.itemTableHeader} ${mode ? styles.itemTableHeaderDark : ""}`}
//             >
//               <span className={styles.colSno}>S.No</span>
//               <span className={styles.colItemNo}>Item No</span>
//               <span className={styles.colProduct}>Product</span>
//               <span className={styles.colProduct}>Collection</span>
//               <span className={styles.colWarehouse}>Warehouse</span>
//             </div>

//             {/* One row per API entry — no grouping */}
//             {results.map((item, idx) => {
//               const alreadyAdded = selectedItems.some(
//                 (s) =>
//                   s.itemNo === item.itemNo &&
//                   s.warehouseId === item.warehouseId,
//               );
//               return (
//                 <div
//                   key={`${item.itemNo}-${item.warehouseId}-${idx}`}
//                   ref={(el) => (rowRefs.current[idx] = el)}
//                   className={`
//                     ${styles.itemTableRow}
//                     ${mode ? styles.itemTableRowDark : ""}
//                     ${idx === currentIndex ? styles.itemHighlighted : ""}
//                     ${alreadyAdded ? styles.itemAlreadyAdded : ""}
//                   `}
//                   onMouseEnter={() => setCurrentIndex(idx)}
//                   onClick={() => !alreadyAdded && handleSelect(item)}
//                 >
//                   <span className={styles.colSno}>{idx + 1}</span>
//                   <span
//                     className={`${styles.colItemNo} ${styles.itemNoText} ${mode ? styles.itemNoTextDark : ""}`}
//                   >
//                     {item.itemNo}
//                   </span>
//                   <span
//                     className={`${styles.colProduct} ${mode ? styles.colTextDark : ""}`}
//                   >
//                     {item.product_name || "—"}
//                   </span>
//                   <span
//                     className={`${styles.colProduct} ${mode ? styles.colTextDark : ""}`}
//                   >
//                     {item.collection_name || "—"}
//                   </span>
//                   <span
//                     className={`${styles.colWarehouse} ${mode ? styles.colTextDark : ""}`}
//                   >
//                     {item.warehouse || "—"}
//                   </span>

//                   {alreadyAdded && (
//                     <span className={styles.itemAddedBadge}>✓ Added</span>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>

//       <p className={`${styles.fieldHint} ${mode ? styles.fieldHintDark : ""}`}>
//         ↑ ↓ navigate &nbsp;·&nbsp; Enter select &nbsp;·&nbsp; × to remove item
//       </p>
//     </div>
//   );
// }

// ------------------------------- Update for multiple Select ------------------------

import { useEffect, useRef, useState } from "react";
import { useItemSearch } from "./useItemSearch";
import styles from "./ItemChipSearch.module.css";

export function ItemChipSearch({
  mode,
  selectedItems,
  onToggle, // add if missing, remove if present
  onRemove,
  warehouseId,
  managerId,
}) {
  const {
    keyword,
    setKeyword,
    results,
    loading,
    currentIndex,
    setCurrentIndex,
  } = useItemSearch(warehouseId, managerId);

  const wrapRef = useRef(null);
  const inputRef = useRef(null);
  const rowRefs = useRef([]);
  const [open, setOpen] = useState(false);

  const isAdded = (item) =>
    selectedItems.some(
      (s) => s.itemNo === item.itemNo && s.warehouseId === item.warehouseId,
    );

  // Toggle only: keep dropdown open, keep keyword and results
  const handleSelect = (item) => {
    onToggle(item);
    inputRef.current?.focus();
  };

  const handleKey = (e) => {
    if (!open || results.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setCurrentIndex((i) => Math.min(i + 1, results.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setCurrentIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      const item = results[currentIndex];
      if (item) handleSelect(item);
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  // Open when there are results for a keyword. Never closes on selection.
  useEffect(() => {
    if (results.length > 0 && keyword.trim().length > 0) setOpen(true);
    else setOpen(false);
  }, [results.length, keyword]);

  // Close only on outside click
  useEffect(() => {
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  useEffect(() => {
    rowRefs.current[currentIndex]?.scrollIntoView({ block: "nearest" });
  }, [currentIndex]);

  return (
    <div className={styles.formGroup}>
      <label className={mode ? styles.labelDark : ""}>Products / Items</label>

      {/* ── Chips ── */}
      {selectedItems.length > 0 && (
        <div
          className={`${styles.chipContainer} ${mode ? styles.chipContainerDark : ""}`}
        >
          {selectedItems.map((item, i) => (
            <span
              key={`${item.itemNo}-${item.warehouseId || i}`}
              className={`${styles.chip} ${mode ? styles.chipDark : ""}`}
            >
              <span className={styles.chipLabel}>{item.itemNo}</span>
              <button
                type="button"
                className={`${styles.chipRemove} ${mode ? styles.chipRemoveDark : ""}`}
                onClick={() => onRemove(item)}
                aria-label={`Remove ${item.itemNo}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}

      {/* ── Search input ── */}
      <div className={styles.itemSearchWrapper} ref={wrapRef}>
        <input
          disabled={!warehouseId}
          ref={inputRef}
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onFocus={() => {
            if (results.length > 0 && keyword.trim()) setOpen(true);
          }}
          onKeyDown={handleKey}
          placeholder={
            warehouseId
              ? "Search by item no or product name..."
              : "Select warehouse first"
          }
          className={`${styles.itemSearchInput} ${mode ? styles.inputDark : ""}`}
          autoComplete="off"
          style={{ cursor: warehouseId ? "pointer" : "not-allowed" }}
        />
        {loading && <span className={styles.itemSearchSpinner} />}

        {/* ── Table Dropdown ── */}
        {open && (
          <div
            className={`${styles.itemDropdown} ${mode ? styles.itemDropdownDark : ""}`}
          >
            <div
              className={`${styles.itemTableHeader} ${mode ? styles.itemTableHeaderDark : ""}`}
            >
              <span className={styles.colSno}>S.No</span>
              <span className={styles.colItemNo}>Item No</span>
              <span className={styles.colProduct}>Product</span>
              <span className={styles.colProduct}>Collection</span>
              <span className={styles.colWarehouse}>Warehouse</span>
            </div>

            {results.map((item, idx) => {
              const added = isAdded(item);
              return (
                <div
                  key={`${item.itemNo}-${item.warehouseId}-${idx}`}
                  ref={(el) => (rowRefs.current[idx] = el)}
                  className={`
                    ${styles.itemTableRow}
                    ${mode ? styles.itemTableRowDark : ""}
                    ${idx === currentIndex ? styles.itemHighlighted : ""}
                    ${added ? styles.itemAlreadyAdded : ""}
                  `}
                  onMouseEnter={() => setCurrentIndex(idx)}
                  onMouseDown={(e) => e.preventDefault()} // keep input focus
                  onClick={() => handleSelect(item)}
                >
                  <span className={styles.colSno}>{idx + 1}</span>
                  <span
                    className={`${styles.colItemNo} ${styles.itemNoText} ${mode ? styles.itemNoTextDark : ""}`}
                  >
                    {item.itemNo}
                  </span>
                  <span
                    className={`${styles.colProduct} ${mode ? styles.colTextDark : ""}`}
                  >
                    {item.product_name || "—"}
                  </span>
                  <span
                    className={`${styles.colProduct} ${mode ? styles.colTextDark : ""}`}
                  >
                    {item.collection_name || "—"}
                  </span>
                  <span
                    className={`${styles.colWarehouse} ${mode ? styles.colTextDark : ""}`}
                  >
                    {item.warehouse || "—"}
                  </span>

                  {added && (
                    <span className={styles.itemAddedBadge}>✓ Added</span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <p className={`${styles.fieldHint} ${mode ? styles.fieldHintDark : ""}`}>
        ↑ ↓ navigate &nbsp;·&nbsp; Enter select / unselect &nbsp;·&nbsp; × to
        remove item
      </p>
    </div>
  );
}
